import { IStoreIndex } from "services/indexdb/interface/istore-index";

const Fields = {
    Name: 'source_id',
    Path: 'sourceId'
}

export const SourceIdUnique: IStoreIndex = {
    Name: Fields.Name,
    Path: Fields.Path,
    Unique: true
}

export const SourceId: IStoreIndex = {
    Name: Fields.Name,
    Path: Fields.Path,
    Unique: false
}